export default __webpack_public_path__ + "static/media/LolChampionGalleryImg_5.6c380bd3.webp";